import React, { useState, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Row, Col, Form, Input, Button, Typography, message, } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';

import { SetUser } from '../../Hooks/Logged';

import axios from 'axios';

export default function LinkAccount() {
  const { state } = useLocation();
  const navigate  = useNavigate();
  const setUser   = useContext(SetUser);

  const [loading, setLoading] = useState(false);

  if (!state?.email) {
    navigate('/login');
    return null;
  }

  const submit = async ({ password }) => {
    setLoading(true);
    try {
      const { data, headers } = await axios.post('/auth/link', {
        email: state.email,
        apple_id:    state.apple_id,
        google_id:   state.google_id,
        facebook_id: state.facebook_id,
        password,
        keep_session: true,
      });

      sessionStorage.setItem('token', headers.authorization);
      sessionStorage.setItem('user', JSON.stringify(data.user));
      axios.defaults.headers.common.Authorization = headers.authorization;

      setUser(data.user); 

      navigate(
        data.user.cliente_id
          ? '/customer/dashboard'
          : data.user.rol_id?.permisos?.dashboard
            ? '/admin/dashboard'
            : '/admin/'
      );
    } catch (err) {
      message.error(err.response?.data?.message || 'Incorrect password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Row className="layout-login" >
      <Col xs={24} md={10} className="col-welcome">
        <div className="logo-container">
          <a href="/">
            <img width="400" src="/logo-white.png" alt="Sneacare" className="logo-login" />
          </a>
        </div>
      </Col>

      <Col xs={24} md={14}>
        <div className="login-form-container">
          <div className="login-form">
            <Row justify="space-between" align="middle" style={{ marginBottom: 32 }}>
              <Button
                type="text"
                icon={<ArrowLeftOutlined style={{ fontSize: 20 }} />}
                style={{ color: '#000' }}
                onClick={() => navigate(-1)}
              />
              <Typography.Text
                style={{ fontFamily: 'Nunito', cursor: 'pointer' }}
                onClick={() => navigate('/password/recovery')}
              >
                Forgot Password
              </Typography.Text>
            </Row>

            <Typography.Title level={2} style={{ fontFamily: 'NunitoBold', color: '#39180e', marginBottom: 8 }}>
              Link Account
            </Typography.Title>

            <Typography.Paragraph style={{ fontFamily: 'NunitoBold', fontSize: 16, marginBottom: 32 }}>
              Please enter your password to connect your account to this email
            </Typography.Paragraph>

            <Form layout="vertical" onFinish={submit} requiredMark={false}>
              <Form.Item
                label="Password"
                name="password"
                rules={[{ required: true, message: 'Enter your password' }]}>
                <Input.Password placeholder="********" size="large" />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  block
                  size="large"
                  loading={loading}
                  style={{
                    marginTop:"15px"
                  }}
                >
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </Col>
    </Row>
  );
}